/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AlertType {
  Danger = "Danger",
  Warning = "Warning",
  Success = "Success",
  Hidden = "Hidden",
}

export interface ApplicantPortable {
  /** @format uuid */
  UserId?: string;
  LastUniversityName?: string | null;
  LastDegreeName?: string | null;
  LastFieldName?: string | null;
  LastGPA?: string | null;
}

/**
 * Represents sub field major
 */
export interface BranchPortable {
  /** @format int32 */
  BranchId?: number;

  /** @format int32 */
  FieldId?: number;
  Title?: string | null;
  Description?: string | null;

  /** @format int32 */
  Position?: number;
  SupportsConsultant?: boolean;
  Hidden?: boolean;
}

export interface BranchesQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: BranchPortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface CancelResourceRequestInput {
  /** @format int32 */
  ResourceRequestId?: number;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface CancelResourceRequestOutput {
  /** @format int32 */
  ResourceRequestId?: number;
}

export interface ChangeChapterStateInput {
  /** @format int32 */
  PlannedChapterId?: number;
  State?: PlannedChapterStates;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ChangeChapterStateOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface ChangeEnrollmentInput {
  /** @format int32 */
  ExamId?: number | null;
  CustomExamTitle?: string | null;

  /** @format int32 */
  FieldId?: number | null;
  CustomFieldTitle?: string | null;

  /** @format int32 */
  BranchId?: number | null;

  /** @format int32 */
  ExamDateId?: number | null;

  /**
   * @format date
   * @example 2023-10-09
   */
  CustomExamDate?: string | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ChangeEnrollmentOutput {
  SchedulesRegenerateNeeded?: boolean;
  Enrollment?: EnrollmentWithExamWithFieldWithBranchPortable;
}

export interface ChangeProgressTypeInput {
  /** @format uuid */
  ConsulteeId?: string | null;

  /** @format int32 */
  PlannedElementId?: number;
  ElementType?: PlannedElementType;
  ProgressType?: ProgressType;

  /**
   * Index of first Page or Test (based on type of chapter).
   * Must be null if ProgressType was Percentage.
   * Must has value less than or equal to LastProgressIndex if ProgressType was Counted.
   * @format int32
   */
  FirstProgressIndex?: number | null;

  /**
   * Index of last Page or Test (based on type of chapter).
   * Must be null if ProgressType was Percentage.
   * Must has value greater than or equal to FirstProgressIndex if ProgressType was Counted.
   * @format int32
   */
  LastProgressIndex?: number | null;
}

export interface ChangeProgressTypeOutput {
  SchedulesRegenerateNeeded?: boolean;
  PlannedElement?: PlannedElementPortable;
}

/**
 * Represent All 400 errors for ChangeProgressTypeOutput
 */
export interface ChangeProgressTypeOutput400Results {
  ItemIndexInvalid?: ItemIndexInvalidDetailsTypedExceptionResponse;
}

export enum ChapterImportances {
  Normal = "Normal",
  Important = "Important",
}

export interface ChapterPortable {
  /** @format int32 */
  ChapterId?: number;

  /** @format int32 */
  ResourceId?: number;
  Title?: string | null;

  /** @format int32 */
  Position?: number;
  Description?: string | null;
  Importance?: ChapterImportances;
  Reviewable?: boolean;
  ContentType?: ElementContentType;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
}

export interface ChapterReportProgressesEntry {
  /** @format int32 */
  PlannedChapterId?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  ProgressIndex?: number;

  /** @format int32 */
  ScheduledElementId?: number | null;
}

/**
* Sample chapter will be selected based on below conditions:
- Last studied chapter by applicant or if not studied any chapter yet,
- First chapter in study list
*/
export interface ChapterSpeedConfigurationOutput {
  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  PredicatedStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  CurrentStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  MinStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  MaxStudyTime?: string;
  SampleChapter?: ChapterPortable;
}

export type ChapterWithResourcePortable = ChapterPortable & {
  Resource?: ResourcePortable;
};

/**
 * <param name="Items"></param>
 */
export interface ChaptersPlannedTimeSumReportsOutput {
  Items?: ScheduledStudyPlannedTimeReportItem[] | null;
}

export interface ChaptersQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: ChapterPortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

/**
 * Command for client to do for upgrading itself
 */
export enum ClientVersionCommands {
  Nothing = "Nothing",
  Upgrade = "Upgrade",
}

export interface ClientVersionPortable {
  /** @format int32 */
  ClientVersionId?: number;
  Type?: string | null;
  Vendor?: string | null;

  /** @format int32 */
  VersionNumber?: number;
  VersionName?: string | null;

  /** @format date-time */
  Released?: string | null;

  /** @format date-time */
  Expiration?: string | null;
  LandingUrl?: string | null;
  DownloadUrl?: string | null;
  UpgradeMessage?: string | null;
  ExpiredMessage?: string | null;
  PrereleaseMessage?: string | null;
}

/**
 * Represent All 400 errors for Config max round
 */
export interface ConfigMaxRound400Results {
  RoundAlreadyDonned?: RoundAlreadyDonnedDetailsTypedExceptionResponse;
}

export interface ConfigMaxRoundInput {
  /** @format int32 */
  PlannedResourceId?: number;

  /** @format int32 */
  MaxRoundsCount?: number;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ConfigMaxRoundOutput {
  /**
   * Applicant view of  PlannedResource/>
   * <param name="PlannedResourceId"></param><param name="EnrollmentId"></param><param name="ResourceId"></param><param name="PartialStudyMethod"></param><param name="ReviewAutomatically"></param><param name="QuizVolume"></param><param name="QuizPart"></param><param name="Round"></param><param name="RangedSpeedFactor"></param><param name="Turbo"></param><param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param><param name="HexadecimalBorderColor"> border color of planned resource in `#XXxxXX` format</param><param name="TotalRoundsCount"></param>
   */
  PlannedResource?: PlannedResourcePortable;
}

/**
 * Represent All 400 errors for config speeds
 */
export interface ConfigSpeeds400Results {
  PlannedResourceNotTurboable?: PlannedResourceNotTurboableDetailsTypedExceptionResponse;
  PlannedResourceNotBelongEnrollment?: PlannedResourceNotBelongEnrollmentDetailsTypedExceptionResponse;
}

/**
* <param name="ConsulteeId"></param>
<param name="Entries"></param>
*/
export interface ConfigSpeedsInput {
  Entries?: PlannedResourceSpeedConfigEntry[] | null;

  /** @format uuid */
  ConsulteeId?: string;
}

export interface ConfigSpeedsOutput {
  SchedulesRegenerateNeeded?: boolean;
}

/**
 * Represent All 400 errors for config speed
 */
export interface ConfigureChapterSpeed400Results {
  PlannedResourceNotTurboable?: PlannedResourceNotTurboableDetailsTypedExceptionResponse;
}

/**
* <param name="ConsulteeId"></param>
<param name="PlannedResourceId"></param>
<param name="ChapterId"></param>
<param name="SpecifiedStudyTime"></param>
<param name="Turbo"></param>
*/
export interface ConfigureChapterSpeedInput {
  /** @format int32 */
  PlannedResourceId?: number;

  /** @format int32 */
  ChapterId?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  SpecifiedStudyTime?: string;
  Turbo?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ConfigureChapterSpeedOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface ConfigureResourceSpeedInput {
  /** @format int32 */
  PlannedResourceId?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  SpecifiedStudyTime?: string;
  Turbo?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ConfigureResourceSpeedOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface CurrentProgressPortable {
  ProgressType?: ProgressType;

  /** @format int32 */
  CompletedProgressIndex?: number;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;

  /** @format double */
  CompletedPercent?: number;
}

export enum ElementContentType {
  Text = "Text",
  Questions = "Questions",
  Audio = "Audio",
  TextAndQuestions = "TextAndQuestions",
  Unspecified = "Unspecified",
}

export interface EnrollmentPortable {
  /** @format int32 */
  EnrollmentId?: number;

  /** @format uuid */
  UserId?: string;

  /**
   * @format date
   * @example 2023-10-09
   */
  PlanStart?: string | null;

  /** Specifies how Study Period will be started */
  StudyPeriodsStartType?: StudyPeriodStartTypes;

  /** @format int32 */
  BranchId?: number | null;
  WeekStart?: ZeroBasedWeekDays;

  /** @format int32 */
  FinalReviewDaysCount?: number;
  ExamDate?: ExamDatePortable;

  /**
   * If exam has specific date, this field is null
   * If exam has not specific date, this field can (and must) has value
   * @format date
   * @example 2023-10-09
   */
  CustomExamDate?: string | null;

  /** If for any reason, StudySchedule needs to be regenerated, this field will be true */
  UpdateNeeded?: boolean;

  /** Determines if user forced to enter study reports or not, will be changed in https://zpl.io/2pg5yBE */
  AutoGenerateApplicantMissedReports?: boolean;
}

export type EnrollmentWithExamWithFieldWithBranchPortable =
  EnrollmentPortable & {
    CustomExamTitle?: string | null;
    CustomFieldTitle?: string | null;
    Exam?: ExamPortable;
    Field?: FieldPortable;
    Branch?: BranchPortable;
  };

export interface ExamDatePortable {
  /** @format int32 */
  ExamDateId?: number;

  /** @format int32 */
  ExamId?: number;

  /**
   * @format date
   * @example 2023-10-09
   */
  Date?: string;
  Title?: string | null;
}

export enum ExamDateTypes {
  Fixed = "Fixed",
  Custom = "Custom",
}

export interface ExamDatesQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: ExamDatePortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ExamPortable {
  /** @format int32 */
  ExamId?: number;
  Title?: string | null;
  DescriptiveTitle?: string | null;
  Description?: string | null;

  /** @format int32 */
  Position?: number;
  DateType?: ExamDateTypes;

  /** نوع یک گره در ساختار درختی را مشخص می‌کند */
  TreeNodeType?: TreeNodeTypes;
  Hidden?: boolean;
}

export interface ExamsQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: ExamPortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ExpiredClientVersionDetails {
  ClientType?: string | null;
  ExpiredClientVersionName?: string | null;

  /**
   * @format date
   * @example 2023-10-09
   */
  Expiration?: string;
  Latest?: ClientVersionPortable;
}

export interface ExpiredClientVersionDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: ExpiredClientVersionDetails;
}

export interface FieldPortable {
  /** @format int32 */
  FieldId?: number;

  /** @format int32 */
  ExamId?: number;
  Title?: string | null;
  DescriptiveTitle?: string | null;
  Slug?: string | null;
  Description?: string | null;

  /** @format int32 */
  Position?: number;

  /** نوع یک گره در ساختار درختی را مشخص می‌کند */
  TreeNodeType?: TreeNodeTypes;
  Hidden?: boolean;
}

export type FieldWithExamPortable = FieldPortable & { Exam?: ExamPortable };

export interface FieldsQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: FieldPortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface FixizeEnrollmentStudyPeriodsStartTypeInput {
  /**
   * Start of study time in Saturday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  SaturdayStartTime?: string;

  /**
   * Start of study time in Sunday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  SundayStartTime?: string;

  /**
   * Start of study time in Monday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  MondayStartTime?: string;

  /**
   * Start of study time in Tuesday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  TuesdayStartTime?: string;

  /**
   * Start of study time in Wednesday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  WednesdayStartTime?: string;

  /**
   * Start of study time in Thursday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  ThursdayStartTime?: string;

  /**
   * Start of study time in Friday in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  FridayStartTime?: string;

  /**
   * time between each StudyPeriod in form of ("HH:mm:ss"), for example ("02:00:00")
   * @example 12:34:56
   */
  Space?: string;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface FixizeEnrollmentStudyPeriodsStartTypeOutput {
  SchedulesRegenerateNeeded?: boolean;
  StudyPeriods?: TimetableItemPortable[] | null;
}

export interface GenerateTimetable400Schemas {
  GenerateTimetableWithZeroDuration?: PlainExceptionResponse;
}

/**
 * parameters to generate enrollment
 */
export interface GenerateTimetableInput {
  /** @format uuid */
  ConsulteeId?: string | null;

  /**
   * Time that applicant wants to study in Saturday
   * @example 12:34:56
   */
  SaturdayDuration?: string;

  /**
   * Time that applicant wants to study in Sunday
   * @example 12:34:56
   */
  SundayDuration?: string;

  /**
   * Time that applicant wants to study in Monday
   * @example 12:34:56
   */
  MondayDuration?: string;

  /**
   * Time that applicant wants to study in Tuesday
   * @example 12:34:56
   */
  TuesdayDuration?: string;

  /**
   * Time that applicant wants to study in Wednesday
   * @example 12:34:56
   */
  WednesdayDuration?: string;

  /**
   * Time that applicant wants to study in Thursday
   * @example 12:34:56
   */
  ThursdayDuration?: string;

  /**
   * Time that applicant wants to study in Friday
   * @example 12:34:56
   */
  FridayDuration?: string;
}

export interface GenerateTimetableOutput {
  TrackingId?: string | null;
  TrackingUrl?: string | null;
  Status?: RequestStatus;

  /** If true, client app must show a message allowing applicant to regenerate study schedule (if applicable) */
  SchedulesRegenerateNeeded?: boolean;

  /** First Schedule Generated (used for showing badge) */
  FirstScheduleGenerated?: boolean;
}

/**
 * جهت حرکت را تعیین می کند
 */
export enum InfiniteScrollDirection {
  Forward = "Forward",
  Backward = "Backward",
}

/**
* Applicant view of a book
<param name="ResourceId"></param><param name="ExternalIdentifier">External resource Identifier</param><param name="Title"></param><param name="Publisher"></param><param name="Authors"></param><param name="Translators"></param><param name="Narrators"></param><param name="Cover"></param><param name="ResourceType"></param><param name="ContentType"></param><param name="ProgressType"></param><param name="TotalProgressIndex"></param><param name="Edition"></param><param name="Priotizable">If has any chapter that is marked as important, allows applicant to select which parts of resource wants to study</param><param name="Volumeable">If has any chapter that is volumeable (testable), allows applicant to select quiz volume</param><param name="Reviewable">If has any reviewable chapter</param><param name="Turboable"></param><param name="ContainChapter"></param>
*/
export type InternalExternalResourcePortable = ResourcePortable & {
  ExternalIdentifier?: string | null;
};

export type ItemIndexInvalidDetails = object;

export interface ItemIndexInvalidDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: ItemIndexInvalidDetails;
}

export enum JobStates {
  None = "None",
  Doing = "Doing",
  Done = "Done",
  Error = "Error",
  Canceled = "Canceled",
  Deleted = "Deleted",
}

export type LoadApplicantProfileOutput = ApplicantPortable;

export interface MicroscopicPlannedResourcesOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: PlannedResourceWithResourcePortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export interface ObjectTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: any;
}

/**
 * Used when applicant wants to change its plan's type from fixed start to orderized start
 */
export interface OrderizeEnrollmentStudyPeriodsStartTypeInput {
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface OrderizeEnrollmentStudyPeriodsStartTypeOutput {
  SchedulesRegenerateNeeded?: boolean;
  StudyPeriods?: TimetableItemPortable[] | null;
}

export interface PackageResourcePortable {
  /** @format int32 */
  PackageResourceId?: number;

  /** @format int32 */
  Position?: number;

  /** @format int32 */
  ResourceId?: number;

  /** @format int32 */
  ResourcePackageId?: number;
}

export interface PackageTheResourceInput {
  /** @format int32 */
  ResourcePackageId?: number;

  /** @format int32 */
  ResourceId?: number;

  /** @format int32 */
  Position?: number;
}

export interface PackageTheResourceOutput {
  PackageResourcePortable?: PackageResourcePortable;
}

export interface PeriodResourceReportPortable {
  /** @format int32 */
  PeriodResourceReportId?: number;

  /** @format int32 */
  PlannedResourceId?: number;

  /** @format int32 */
  PlannedResourceCompletedPercent?: number;
}

export type PeriodResourceReportWithPlannedResourceWithResourcePortable =
  PeriodResourceReportPortable & {
    CompletedPercent?: number;
    PlannedResource?: PlannedResourceWithResourcePortable;
  };

export interface PeriodicElementEntry {
  /** @format int32 */
  RelatedElementId?: number;
  ElementType?: PeriodicElementType;
  Title?: string | null;

  /** @format int32 */
  PreviousReadPercent?: number;

  /** @format int32 */
  CurrentReadPercent?: number;

  /** @format int32 */
  OutOfPlanReadPercent?: number;

  /** @format int32 */
  CurrentRemainedPercent?: number;

  /** @format int32 */
  FutureReadPercent?: number;
}

export interface PeriodicElementPortable {
  /** @format int32 */
  ResourceId?: number;
  Title?: string | null;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Items?: PeriodicElementEntry[] | null;
}

export interface PeriodicElementReportsOutput {
  Elements?: PeriodicElementPortable[] | null;
}

export enum PeriodicElementType {
  Resource = "Resource",
  Chapter = "Chapter",
}

export interface PersistTimetableItem400Results {
  StudyPeriodMaxPlannableTimeExceed?: StudyPeriodMaxPlannableTimeExceedDetailsTypedExceptionResponse;
  TimetableItemOverlaps?: TimetableItemOverlapsDetailsTypedExceptionResponse;
  StudyPeriodInvalidPosition?: StudyPeriodInvalidPositionDetailsTypedExceptionResponse;
}

export interface PersistTimetableItemInput {
  /** @format int32 */
  TimetableItemId?: number | null;
  Weekday?: ZeroBasedWeekDays;

  /** Types of BasicStudyPeriods */
  Type?: TimetableItemTypes;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Start?: string | null;

  /** @format int32 */
  Ordinal?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Duration?: string;

  /** @format int32 */
  ResourceId?: number | null;
  Comment?: string | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface PersistTimetableItemOutput {
  SchedulesRegenerateNeeded?: boolean;

  /**
   * Applicant view of TimetableItemEntity/>
   * <param name="BasicStudyPeriodId"></param><param name="EnrollmentId">Enrollment that this study period belongs to</param><param name="Position">If related Segaam.Planning.InternalContracts.Plan.IEnrollmentEntity.StudyPeriodsStartType equals to Segaam.Planning.InternalContracts.Enrollment.StudyPeriodStartTypes.Ordinary, this property order number and position of this study period</param><param name="Start">If related Segaam.Planning.InternalContracts.Plan.IEnrollmentEntity.StudyPeriodsStartType equals to Segaam.Planning.InternalContracts.Enrollment.StudyPeriodStartTypes.Fixed, this property holds exact time of beginning. This value is measured from beginning of day (00:00:00) and must not be negative or more than 23:59:59</param><param name="Duration">Time planned for this study period</param><param name="ResourceId"></param><param name="Type">Holds type of a StudyPeriod (any of Resource, Review and Free)</param><param name="Comment">Used for comment of SP if SP type was Free</param><param name="WeekDay">Day of week that this periods belongs to it</param>
   */
  Persisted?: TimetableItemPortable;
}

export type PlainExceptionResponse = ObjectTypedExceptionResponse;

export interface PlainExceptionResponseTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: PlainExceptionResponse;
}

export interface PlanChapterEntry {
  /** @format int32 */
  PlannedChapterId?: number;

  /** @format int32 */
  Position?: number;
  State?: PlannedChapterStates;
}

export type PlanChapterInput = PlanChapterEntry & {
  ConsulteeId?: string | null;
};

export interface PlanChapterOutput {
  /**
   * <param name="PlannedChapterId"></param>
   * <param name="ChapterId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="CompletedPercent"></param>
   * <param name="CompletedProgressIndex"></param>
   * <param name="State"></param>
   * <param name="Position"></param>
   * <param name="ProgressType"></param>
   * <param name="FirstProgressIndex"></param>
   * <param name="LastProgressIndex"></param>
   */
  Planned?: PlannedChapterPortable;
  SchedulesRegenerateNeeded?: boolean;
}

export interface PlanChaptersInput {
  /** @format uuid */
  ConsulteeId?: string | null;
  PlanndChapters: PlanChapterEntry[];
}

export interface PlanChaptersOutput {
  Results?: PlanChapterOutput[] | null;
  SchedulesRegenerateNeeded?: boolean;
}

export interface PlanResourceEntry {
  /** @format int32 */
  ResourceId?: number;

  /** @format int32 */
  PlannedResourceId?: number;
  Result?: PlanResourceResults;
  PlannedResource?: PlannedResourcePlusResourceRequestPortable;
}

/**
 * Input of service to adding book to plan
 */
export interface PlanResourceInput {
  /** @format int32 */
  ResourceId?: number;

  /** @format uuid */
  ConsulteeId?: string | null;
}

/**
 * Input of service to adding book to plan
 */
export type PlanResourceOutput = PlanResourceEntry & {
  SchedulesRegenerateNeeded?: boolean;
};

export enum PlanResourceResults {
  PlannedSuccessfully = "PlannedSuccessfully",
  PreviouselyPlanned = "PreviouselyPlanned",
  Replanned = "Replanned",
}

export interface PlanResourcesInput {
  /** @format uuid */
  ConsulteeId?: string | null;
  ResourceIds: number[];
}

export interface PlanResourcesOutput {
  SchedulesRegenerateNeeded?: boolean;
  Results?: PlanResourceEntry[] | null;
}

/**
* <param name="PlannedChapterId"></param>
<param name="ChapterId"></param>
<param name="EnrollmentId"></param>
<param name="CompletedPercent"></param>
<param name="CompletedProgressIndex"></param>
<param name="State"></param>
<param name="Position"></param>
<param name="ProgressType"></param>
<param name="FirstProgressIndex"></param>
<param name="LastProgressIndex"></param>
*/
export interface PlannedChapterPortable {
  /** @format int32 */
  PlannedChapterId?: number;

  /** @format int32 */
  ChapterId?: number;

  /** @format int32 */
  EnrollmentId?: number;

  /** @format int32 */
  CompletedPercent?: number;

  /** @format int32 */
  CompletedProgressIndex?: number;
  State?: PlannedChapterStates;

  /** @format int32 */
  Position?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
}

export interface PlannedChapterProgressPortable {
  /** @format int32 */
  PlannedChapterProgressId?: number;

  /** @format int32 */
  ScheduledPeriodId?: number | null;

  /** @format int32 */
  PlannedChapterId?: number;

  /** @format int32 */
  EnrollmentId?: number;
  AutoGenerated?: boolean;

  /** @format int32 */
  ScheduledElementId?: number | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
  QuizVolume?: PlannedResourceQuizVolumes;
  QuizPart?: PlannedResourceQuizParts;

  /** @format int32 */
  ReportedProgressIndex?: number;

  /** @format int32 */
  ReportedPercent?: number;

  /** @format int32 */
  ComputedPercent?: number;

  /**
   * @format date-time
   * @example 2023-10-09T09:27:28.7267579Z
   */
  EffectedInstant?: string | null;
}

export interface PlannedChapterQueryOutput {
  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;

  /**
   * Maximum count of available page based on total records count and size of each page
   * @format int32
   */
  PageCount?: number | null;
  Items?: PlannedChapterWithChapterWithFocusedPortable[] | null;

  /** @format int32 */
  PageIndex?: number;

  /** @format int32 */
  PageSize?: number;
}

export enum PlannedChapterStates {
  Enabled = "Enabled",
  Postponed = "Postponed",
  Removed = "Removed",
  Unimportant = "Unimportant",
}

export type PlannedChapterWithChapterPortable = PlannedChapterPortable & {
  Chapter?: ChapterPortable;
};

export type PlannedChapterWithChapterWithFocusedPortable =
  PlannedChapterWithFocusedPortable & {
    Chapter?: ChapterPortable;
    Postponed?: boolean;
  };

export type PlannedChapterWithChapterWithResourcePortable =
  PlannedChapterPortable & { Chapter?: ChapterWithResourcePortable };

/**
* <param name="PlannedChapterId"></param>
<param name="ChapterId"></param>
<param name="EnrollmentId"></param>
<param name="CompletedPercent"></param>
<param name="CompletedProgressIndex"></param>
<param name="State"></param>
<param name="Focused">
            Planned chapter will be in focus if is in user's focus, for example if user studied it recently or will study it in near future.
            Focused chapter must be shown in first view of before expanding view to all chapters, and when user collapsed all chapters to focused chapters
            </param>
<param name="Position"></param>
<param name="ProgressType"></param>
<param name="FirstProgressIndex"></param>
<param name="LastProgressIndex"></param>
*/
export interface PlannedChapterWithFocusedPortable {
  /** @format int32 */
  PlannedChapterId?: number;

  /** @format int32 */
  ChapterId?: number;

  /** @format int32 */
  EnrollmentId?: number;

  /** @format double */
  CompletedPercent?: number;

  /** @format int32 */
  CompletedProgressIndex?: number;
  State?: PlannedChapterStates;

  /** @format int32 */
  Position?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
  Focused?: boolean;
}

export interface PlannedElementPortable {
  /** @format int32 */
  RelatedElementId?: number;
  ElementType?: PlannedElementType;
  Title?: string | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;

  /** @format int32 */
  ProgressIndex?: number;

  /** @format double */
  ComputedPercent?: number;

  /** @format int32 */
  Position?: number;
}

export enum PlannedElementType {
  Resource = "Resource",
  Chapter = "Chapter",
}

export interface PlannedResourceAnalysisPortable {
  /** @format int32 */
  PlannedResourceId?: number;

  /**
   * @format date
   * @example 2023-10-09
   */
  RoundFinish?: string | null;
  State?: PlannedResourceStates;
}

export type PlannedResourceAnalysisWithPlannedResourceWithResourcePortable =
  PlannedResourceAnalysisPortable & {
    Position?: number;
    PlannedResource?: PlannedResourceWithResourcePortable;
  };

export interface PlannedResourceDetailsOutput {
  /**
   * <param name="PlannedResourceId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ResourceId"></param>
   * <param name="PartialStudyMethod"></param>
   * <param name="ReviewAutomatically"></param>
   * <param name="QuizVolume"></param>
   * <param name="QuizPart"></param>
   * <param name="Round"></param>
   * <param name="RangedSpeedFactor"></param>
   * <param name="Turbo"></param>
   * <param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param>
   * <param name="HexadecimalBorderColor">border color of planned resource in `#XXxxXX` format</param>
   * <param name="TotalRoundsCount"></param>
   * <param name="Resource"></param>
   */
  PlannedResource?: PlannedResourceWithResourcePortable;

  /** Expermental. Indicates that requester can edit planned resource or not */
  Editable?: boolean;

  /** Expermental. If requester can not edit planned resource, this message will be shown to him or her */
  UneditableComment?: string | null;

  /** Expermental. If requester can not edit planned resource, this field inform client app about why requester can not edit. possible values are (**PermissionDenied** and **PackagePlanNeeded** ) */
  UneditableReason?: string | null;
}

export type PlannedResourceNotBelongEnrollmentDetails = object;

export interface PlannedResourceNotBelongEnrollmentDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: PlannedResourceNotBelongEnrollmentDetails;
}

export type PlannedResourceNotTurboableDetails = object;

export interface PlannedResourceNotTurboableDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: PlannedResourceNotTurboableDetails;
}

export interface PlannedResourcePlusResourceRequestPortable {
  /** @format int32 */
  ResourceId?: number | null;

  /**
   * Applicant view of a book
   * <param name="ResourceId"></param><param name="Title"></param><param name="Publisher"></param><param name="Authors"></param><param name="Translators"></param><param name="Narrators"></param><param name="Cover"></param><param name="ResourceType"></param><param name="ContentType"></param><param name="ProgressType"></param><param name="TotalProgressIndex"></param><param name="Edition"></param><param name="Priotizable">If has any chapter that is marked as important, allows applicant to select which parts of resource wants to study</param><param name="Volumeable">If has any chapter that is volumeable (testable), allows applicant to select quiz volume</param><param name="Reviewable">If has any reviewable chapter</param><param name="Turboable"></param><param name="ContainChapter"></param>
   */
  Resource?: ResourcePortable;

  /** @format int32 */
  PlannedResourceId?: number | null;

  /**
   * Applicant view of  PlannedResource/>
   * <param name="PlannedResourceId"></param><param name="EnrollmentId"></param><param name="ResourceId"></param><param name="PartialStudyMethod"></param><param name="ReviewAutomatically"></param><param name="QuizVolume"></param><param name="QuizPart"></param><param name="Round"></param><param name="RangedSpeedFactor"></param><param name="Turbo"></param><param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param><param name="HexadecimalBorderColor"> border color of planned resource in `#XXxxXX` format</param><param name="TotalRoundsCount"></param>
   */
  PlannedResource?: PlannedResourcePortable;
  ProgressionSubject?: ResourceProgressionSubject;
  ResourceProgress?: CurrentProgressPortable;
  ResourceRequest?: ResourceRequestCorePortable;

  /**
   * @format date-time
   * @example 2023-10-09T09:27:28.7267579Z
   */
  Instant?: string;
  FocusedChapters?: PlannedChapterWithChapterWithFocusedPortable[] | null;
}

/**
* Applicant view of  PlannedResource/>
<param name="PlannedResourceId"></param><param name="EnrollmentId"></param><param name="ResourceId"></param><param name="PartialStudyMethod"></param><param name="ReviewAutomatically"></param><param name="QuizVolume"></param><param name="QuizPart"></param><param name="Round"></param><param name="RangedSpeedFactor"></param><param name="Turbo"></param><param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param><param name="HexadecimalBorderColor"> border color of planned resource in `#XXxxXX` format</param><param name="TotalRoundsCount"></param>
*/
export interface PlannedResourcePortable {
  /** @format int32 */
  PlannedResourceId?: number;

  /** @format int32 */
  EnrollmentId?: number;

  /** @format int32 */
  ResourceId?: number;

  /** Which chapters applicant wants to read */
  PartialStudyMethod?: PlannedResourceStudyParts;
  ReviewAutomatically?: boolean;
  QuizVolume?: PlannedResourceQuizVolumes;
  QuizPart?: PlannedResourceQuizParts;

  /** @format int32 */
  Round?: number;

  /** @format double */
  RangedSpeedFactor?: number;
  Turbo?: boolean;
  HexadecimalColor?: string | null;
  HexadecimalBorderColor?: string | null;

  /** @format int32 */
  TotalRoundsCount?: number;
}

export interface PlannedResourceProgressPortable {
  /** @format int32 */
  PlannedResourceProgressId?: number;

  /** @format int32 */
  ScheduledPeriodId?: number | null;

  /** @format int32 */
  PlannedResourceId?: number;

  /** @format int32 */
  EnrollmentId?: number;
  AutoGenerated?: boolean;

  /** @format int32 */
  ScheduledElementId?: number | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
  QuizVolume?: PlannedResourceQuizVolumes;
  QuizPart?: PlannedResourceQuizParts;

  /** @format int32 */
  ReportedProgressIndex?: number;

  /** @format int32 */
  ReportedPercent?: number;

  /** @format int32 */
  ComputedPercent?: number;

  /**
   * @format date-time
   * @example 2023-10-09T09:27:28.7267579Z
   */
  EffectedInstant?: string | null;
}

export enum PlannedResourceQuizParts {
  AllOrOddsOrEveryOneOfThird = "AllOrOddsOrEveryOneOfThird",
  EvensOrEveryTwoOfThird = "EvensOrEveryTwoOfThird",
  EveryThreeOfThird = "EveryThreeOfThird",
}

export enum PlannedResourceQuizVolumes {
  All = "All",
  OneHalf = "OneHalf",
  OneThird = "OneThird",
}

/**
 * <para name="Turbo">Consultant can only turn off Turbo mode</para>
 */
export interface PlannedResourceSpeedConfigEntry {
  /** @format int32 */
  PlannedResourceId?: number;

  /** @format double */
  SpeedFactor?: number;
  Turbo?: boolean;
}

export enum PlannedResourceStates {
  Unscheduled = "Unscheduled",
  Scheduled = "Scheduled",
  Finished = "Finished",
}

/**
 * Which chapters applicant wants to read
 */
export enum PlannedResourceStudyParts {
  Importants = "Importants",
  All = "All",
}

/**
* <param name="PlannedResourceId"></param>
<param name="EnrollmentId"></param>
<param name="ResourceId"></param>
<param name="PartialStudyMethod"></param>
<param name="ReviewAutomatically"></param>
<param name="QuizVolume"></param>
<param name="QuizPart"></param>
<param name="Round"></param>
<param name="RangedSpeedFactor"></param>
<param name="Turbo"></param>
<param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param>
<param name="HexadecimalBorderColor">border color of planned resource in `#XXxxXX` format</param>
<param name="TotalRoundsCount"></param>
<param name="Resource"></param>
*/
export type PlannedResourceWithResourcePortable = PlannedResourcePortable & {
  Resource?: ResourcePortable;
};

/**
* <param name="PlannedResourceId"></param>
<param name="EnrollmentId"></param>
<param name="ResourceId"></param>
<param name="PartialStudyMethod"></param>
<param name="ReviewAutomatically"></param>
<param name="QuizVolume"></param>
<param name="QuizPart"></param>
<param name="Round"></param>
<param name="RangedSpeedFactor"></param>
<param name="Turbo"></param>
<param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param>
<param name="HexadecimalBorderColor">border color of planned resource in `#XXxxXX` format</param>
<param name="TotalRoundsCount"></param>
<param name="Resource"></param>
<param name="FocusedChapters"></param>
*/
export type PlannedResourceWithResourceWithFocusedChaptersPortable =
  PlannedResourcePortable & {
    Resource?: ResourcePortable;
    FocusedChapters?: PlannedChapterWithChapterWithFocusedPortable[] | null;
  };

export interface PlannedResourcesQueryOutput {
  /** Returning Items */
  Items?: PlannedResourcePlusResourceRequestPortable[] | null;

  /** corresponding to the first cursor of Items */
  StartCursor?: string | null;

  /** corresponding to the last cursor of Items */
  EndCursor?: string | null;

  /** is used to indicate whether more edges exist following the set defined by the clients arguments */
  HasNext?: boolean;

  /** is used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  HasPrevious?: boolean;

  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
}

/**
* <param name="ConsulteeId"></param>
<param name="ScheduledElementId"></param>
<param name="PersistConfirmationSkipped">True to persist related option</param>
*/
export interface PostponeChapterInput {
  /** @format int32 */
  ScheduledElementId?: number;
  PersistConfirmationSkipped?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface PostponeChapterOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface PreviewExternalResourceOutput {
  ExternalIdentifier?: string | null;
  Title?: string | null;
  ResourceType?: ResourceType;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Narrators?: string | null;
  ISBN10?: string | null;
  ISBN13?: string | null;

  /** @format int32 */
  Edition?: number | null;
  Cover?: string | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  TotalProgressIndex?: number;

  /** @format int32 */
  LanguageId?: number | null;
  RequestType?: ResourceRequestType;
  ReferenceLink?: string | null;
}

export interface ProgressIntervalPortable {
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;
}

export enum ProgressType {
  Percentage = "Percentage",
  Page = "Page",
  QuestionNumber = "QuestionNumber",
  Seconds = "Seconds",
}

export interface ProgressValueInvalidDetails {
  ValidRange?: string | null;
}

export interface ProgressValueInvalidDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: ProgressValueInvalidDetails;
}

export enum RegenerateStudyScheduleDay {
  Today = "Today",
  Tomorrow = "Tomorrow",
}

export interface RegenerateStudyScheduleInput {
  From?: RegenerateStudyScheduleDay;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface RegenerateStudyScheduleOutput {
  TrackingId?: string | null;
  TrackingUrl?: string | null;
  Status?: RequestStatus;
  SchedulesRegenerateNeeded?: boolean;

  /** First Schedule Generated (used for showing badge) */
  FirstScheduleGenerated?: boolean;
}

export interface RemoteUploadResourceRequestImageInput {
  ImageUrl?: string | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface RemoteUploadResourceRequestImageOutput {
  /** @format int32 */
  FileId?: number;
  Thumbnail?: string | null;
}

export interface RemoveAllTimetableItemsOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface RemoveTimetableItemOutput {
  SchedulesRegenerateNeeded?: boolean;
}

/**
 * Represent All 400 errors for Report Progresses
 */
export interface ReportProgresses400Results {
  ProgressValueInvalid?: ProgressValueInvalidDetailsTypedExceptionResponse;
}

export interface ReportProgressesInput {
  Chapters?: ChapterReportProgressesEntry[] | null;
  Resources?: ResourceReportProgressesEntry[] | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ReportProgressesOutput {
  SchedulesRegenerateNeeded?: boolean;
  Chapters?: PlannedChapterProgressPortable[] | null;
  Resources?: PlannedResourceProgressPortable[] | null;
}

/**
* <param name="ConsulteeId"></param>
<param name="ScheduledChapterReviewId"></param>
<param name="Reviewed"></param>
*/
export interface ReportReviewInput {
  /** @format int32 */
  ScheduledChapterReviewId?: number;
  Reviewed?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ReportReviewOutput {
  SchedulesRegenerateNeeded?: boolean;

  /**
   * <param name="ScheduledChapterReviewId"></param>
   * <param name="StudySchedulPeriodId"></param>
   * <param name="PlannedChapter"></param>
   * <param name="PlannedResource"></param>
   * <param name="Reviewed"></param>
   * <param name="Position"></param>
   * <param name="Round">Round of reviewing resource</param>
   */
  Review?: ScheduledChapterReviewWithPlannedChapterPortable;
}

export interface ReportableElementPortable {
  /** @format int32 */
  ResourceId?: number;
  ResourceTitle?: string | null;
  Items?: PlannedElementPortable[] | null;
}

export interface ReportableElementsOutput {
  /**
   * <param name="ScheduledPeriodId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ExamPeriod">If this period, is last period before exam</param>
   * <param name="StudiedHoursCount"></param>
   * <param name="FinishedChaptersCount"></param>
   * <param name="TotalChaptersCount"></param>
   * <param name="UnplannedChaptersCount"></param>
   * <param name="StartDate"></param>
   * <param name="EndDate"></param>
   * <param name="Type"></param>
   * <param name="Index">Index of period, such as 23</param>
   */
  Period?: ScheduledPeriodPortable;
  Elements?: ReportableElementPortable[] | null;
}

export enum RequestResourceActionType {
  PlanResource = "PlanResource",
  Link = "Link",
}

export interface RequestResourceActionValueObject {
  Title?: string | null;
  Icon?: string | null;
  ActionType?: RequestResourceActionType;
  Params?: Record<string, string>;
}

export interface RequestResourceActivityPortable {
  /** @format int32 */
  ResourceRequestActivityId?: number;

  /** @format int32 */
  ResourceRequestId?: number;
  Message?: string | null;
  Action?: RequestResourceActionValueObject;
  MessageType?: AlertType;

  /** @format date-time */
  Created?: string;
}

export interface RequestResourceChapterInput {
  Title?: string | null;
  ContentType?: ElementContentType;
  Progresses?: ProgressIntervalPortable[] | null;
}

export interface RequestResourceImageInput {
  ImageType?: ResourceImageType;

  /** @format int32 */
  FileId?: number;
}

export interface RequestResourceImagePortable {
  /** @format int32 */
  FileId?: number;
  ImageType?: ResourceImageType;
  ImageUrl?: string | null;
}

export interface RequestResourceInput {
  Title?: string | null;
  ResourceType?: ResourceType;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Narrators?: string | null;
  ISBN10?: string | null;
  ISBN13?: string | null;

  /** @format int32 */
  Edition?: number | null;

  /** @format int32 */
  CoverFileId?: number | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  TotalProgressIndex?: number;

  /** @format int32 */
  LanguageId?: number | null;
  RequestType?: ResourceRequestType;
  ReferenceLink?: string | null;
  ExternalIdentifier?: string | null;
  Images?: RequestResourceImageInput[] | null;
  Chapters?: RequestResourceChapterInput[] | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface RequestResourceOutput {
  /** @format int32 */
  ResourceRequestId?: number | null;

  /** @format int32 */
  ResourceId?: number | null;

  /** @format int32 */
  PlannedResourceId?: number | null;
  Status?: ResourceRequestStatus;
  LastActivity?: RequestResourceActivityPortable;
}

export enum RequestStatus {
  Succeeded = "Succeeded",
  Failed = "Failed",
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  InProgress = "InProgress",
}

export interface ResetEnrollmentInput {
  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface ResetEnrollmentOutput {
  SchedulesRegenerateNeeded?: boolean;
  Enrollment?: EnrollmentPortable;
}

export enum ResourceImageType {
  Others = "Others",
  Cover = "Cover",
  Copyright = "Copyright",
  TableOfContents = "TableOfContents",
}

export interface ResourcePackagePersistInput {
  /** @format int32 */
  ResourcePackageId?: number | null;

  /** @format int32 */
  Position?: number;

  /** @format int32 */
  BranchId?: number;
  Published?: boolean;
  Subtitle?: string | null;
  Title?: string | null;
}

export interface ResourcePackagePersistOutput {
  ResourcePackagePortable?: ResourcePackagePortable;
}

export interface ResourcePackagePortable {
  /** @format int32 */
  ResourcePackageId?: number;

  /**
   * Position of this package against other packages, lower, means upper or sooner
   * @format int32
   */
  Position?: number;

  /** Title of package */
  Title?: string | null;

  /** Subtitle of package that will be displayed below of title in list of packages */
  Subtitle?: string | null;

  /**
   * Branch who this package is generated for
   * @format int32
   */
  BranchId?: number;

  /** service types that applicant must has to be able to use this package */
  NeededServiceTypes?: string[] | null;

  /** Defines how a resource package is */
  Type?: ResourcePackageTypes;
}

export interface ResourcePackageResourcesOutput {
  Resources?: ResourcePortable[] | null;
  UnskippableResourcesIds?: number[] | null;
}

/**
 * Defines how a resource package is
 */
export enum ResourcePackageTypes {
  PredefinedResources = "PredefinedResources",
  ConsultantProposed = "ConsultantProposed",
}

/**
* Applicant view of a book
<param name="ResourceId"></param><param name="Title"></param><param name="Publisher"></param><param name="Authors"></param><param name="Translators"></param><param name="Narrators"></param><param name="Cover"></param><param name="ResourceType"></param><param name="ContentType"></param><param name="ProgressType"></param><param name="TotalProgressIndex"></param><param name="Edition"></param><param name="Priotizable">If has any chapter that is marked as important, allows applicant to select which parts of resource wants to study</param><param name="Volumeable">If has any chapter that is volumeable (testable), allows applicant to select quiz volume</param><param name="Reviewable">If has any reviewable chapter</param><param name="Turboable"></param><param name="ContainChapter"></param>
*/
export interface ResourcePortable {
  /** @format int32 */
  ResourceId?: number;
  Title?: string | null;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Narrators?: string | null;
  Cover?: string | null;
  ResourceType?: ResourceType;
  ContentType?: ElementContentType;
  ProgressType?: ProgressType;

  /** @format int32 */
  TotalProgressIndex?: number;

  /** @format int32 */
  Edition?: number | null;
  Priotizable?: boolean;
  Volumeable?: boolean;
  Reviewable?: boolean;
  Turboable?: boolean;
  ContainChapter?: boolean;
}

export enum ResourceProgressionSubject {
  None = "None",
  Chapter = "Chapter",
  Resource = "Resource",
}

export interface ResourceQueryOutput {
  /** Returning Items */
  Items?: InternalExternalResourcePortable[] | null;

  /** corresponding to the first cursor of Items */
  StartCursor?: string | null;

  /** corresponding to the last cursor of Items */
  EndCursor?: string | null;

  /** is used to indicate whether more edges exist following the set defined by the clients arguments */
  HasNext?: boolean;

  /** is used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  HasPrevious?: boolean;

  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
}

export interface ResourceReportProgressesEntry {
  /** @format int32 */
  PlannedResourceId?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  ProgressIndex?: number;

  /** @format int32 */
  ScheduledElementId?: number | null;
}

export interface ResourceRequestCorePortable {
  /** @format int32 */
  ResourceRequestId?: number;
  Status?: ResourceRequestStatus;
  LastActivity?: RequestResourceActivityPortable;
}

export interface ResourceRequestPortable {
  /** @format int32 */
  ResourceRequestId?: number;
  Title?: string | null;
  ResourceType?: ResourceType;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Narrators?: string | null;
  ISBN10?: string | null;
  ISBN13?: string | null;

  /** @format int32 */
  Edition?: number | null;

  /** @format int32 */
  CoverFileId?: number | null;
  Cover?: string | null;
  ProgressType?: ProgressType;

  /** @format int32 */
  TotalProgressIndex?: number;

  /** @format int32 */
  LanguageId?: number | null;
  ReferenceLink?: string | null;
  Images?: RequestResourceImagePortable[] | null;
  Status?: ResourceRequestStatus;
  LastActivity?: RequestResourceActivityPortable;
}

export enum ResourceRequestStatus {
  None = "None",
  Validating = "Validating",
  Processing = "Processing",
  Rejected = "Rejected",
  NeedAttention = "NeedAttention",
  Succeeded = "Succeeded",
}

export enum ResourceRequestType {
  Manual = "Manual",
  Operator = "Operator",
}

export interface ResourceSpeedConfigurationOutput {
  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  PredicatedStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  CurrentStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  MinStudyTime?: string;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  MaxStudyTime?: string;
}

export enum ResourceType {
  Printed = "Printed",
  EBook = "EBook",
  AudioBook = "AudioBook",
}

/**
* <param name="Period">Information of selected period</param>
<param name="Reports"></param>
*/
export interface ResourcesProgressReportsOutput {
  /**
   * <param name="ScheduledPeriodId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ExamPeriod">If this period, is last period before exam</param>
   * <param name="StudiedHoursCount"></param>
   * <param name="FinishedChaptersCount"></param>
   * <param name="TotalChaptersCount"></param>
   * <param name="UnplannedChaptersCount"></param>
   * <param name="StartDate"></param>
   * <param name="EndDate"></param>
   * <param name="Type"></param>
   * <param name="Index">Index of period, such as 23</param>
   */
  Period?: ScheduledPeriodPortable;
  Reports?:
    | PeriodResourceReportWithPlannedResourceWithResourcePortable[]
    | null;
}

export type RoundAlreadyDonnedDetails = object;

export interface RoundAlreadyDonnedDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: RoundAlreadyDonnedDetails;
}

export interface ScheduledChapterReviewPortable {
  /** @format int32 */
  ScheduledChapterReviewId?: number;

  /** @format int32 */
  StudySchedulPeriodId?: number;

  /** @format int32 */
  PlannedChapterId?: number;

  /** @format int32 */
  PlannedResourceId?: number;
  Reviewed?: boolean;

  /** @format int32 */
  Position?: number;

  /** @format int32 */
  Round?: number;
}

/**
* <param name="ScheduledChapterReviewId"></param>
<param name="StudySchedulPeriodId"></param>
<param name="PlannedChapter"></param>
<param name="PlannedResource"></param>
<param name="Reviewed"></param>
<param name="Position"></param>
<param name="Round">Round of reviewing resource</param>
*/
export type ScheduledChapterReviewWithPlannedChapterPortable =
  ScheduledChapterReviewPortable & {
    PlannedChapter?: PlannedChapterWithChapterPortable;
    PlannedResource?: PlannedResourceWithResourcePortable;
  };

/**
* <param name="Period">Information of selected period</param>
<param name="Items">List of items scheduled to review for selected period, if period was current period, all review items, and if was previous period, only done reviews will be returned</param>
*/
export interface ScheduledChapterReviewsOutput {
  /**
   * <param name="ScheduledPeriodId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ExamPeriod">If this period, is last period before exam</param>
   * <param name="StudiedHoursCount"></param>
   * <param name="FinishedChaptersCount"></param>
   * <param name="TotalChaptersCount"></param>
   * <param name="UnplannedChaptersCount"></param>
   * <param name="StartDate"></param>
   * <param name="EndDate"></param>
   * <param name="Type"></param>
   * <param name="Index">Index of period, such as 23</param>
   */
  Period?: ScheduledPeriodPortable;
  Items?: ScheduledChapterReviewWithPlannedChapterPortable[] | null;
}

export interface ScheduledElementItem {
  /** @format int32 */
  ScheduledElementId?: number;
  ScheduledElementType?: ScheduledElementType;
  Title?: string | null;
  ContentType?: ElementContentType;
  Postponed?: boolean;
  Reported?: boolean;

  /** @format double */
  ProgrammedItems?: number;

  /** @format int32 */
  PlannedElementId?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  FirstProgressIndex?: number;

  /** @format int32 */
  LastProgressIndex?: number;

  /** @format int32 */
  ProgressIndex?: number;

  /** @format double */
  CompletedPercent?: number;
  QuizVolume?: PlannedResourceQuizVolumes;
  QuizPart?: PlannedResourceQuizParts;

  /** @format int32 */
  Position?: number;
}

export enum ScheduledElementType {
  Chapter = "Chapter",
  Resource = "Resource",
}

/**
* <param name="ScheduledPeriodId"></param>
<param name="EnrollmentId"></param>
<param name="ExamPeriod">If this period, is last period before exam</param>
<param name="StudiedHoursCount"></param>
<param name="FinishedChaptersCount"></param>
<param name="TotalChaptersCount"></param>
<param name="UnplannedChaptersCount"></param>
<param name="StartDate"></param>
<param name="EndDate"></param>
<param name="Type"></param>
<param name="Index">Index of period, such as 23</param>
*/
export interface ScheduledPeriodPortable {
  /** @format int32 */
  ScheduledPeriodId?: number;

  /** @format int32 */
  EnrollmentId?: number;
  ExamPeriod?: boolean;

  /** @format int32 */
  StudiedHoursCount?: number;

  /** @format int32 */
  FinishedChaptersCount?: number;

  /** @format int32 */
  TotalChaptersCount?: number;

  /** @format int32 */
  UnplannedChaptersCount?: number;

  /**
   * @format date
   * @example 2023-10-09
   */
  StartDate?: string;

  /**
   * @format date
   * @example 2023-10-09
   */
  EndDate?: string;
  Type?: ScheduledPeriodTypes;

  /** @format int32 */
  Index?: number;
}

export enum ScheduledPeriodTypes {
  Week = "Week",
}

export interface ScheduledStudyPlannedResourcePortable {
  /** @format int32 */
  PlannedResourceId?: number;
  HexadecimalColor?: string | null;
  HexadecimalBorderColor?: string | null;

  /** @format int32 */
  ResourceId?: number;
  ResourceTitle?: string | null;
  ResourcePublisher?: string | null;
  ResourceAuthors?: string | null;
  ResourceContentType?: ElementContentType;
}

export interface ScheduledStudyPlannedTimeReportItem {
  /**
   * <param name="PlannedResourceId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ResourceId"></param>
   * <param name="PartialStudyMethod"></param>
   * <param name="ReviewAutomatically"></param>
   * <param name="QuizVolume"></param>
   * <param name="QuizPart"></param>
   * <param name="Round"></param>
   * <param name="RangedSpeedFactor"></param>
   * <param name="Turbo"></param>
   * <param name="HexadecimalColor">color of planned resource in `#XXxxXX` format</param>
   * <param name="HexadecimalBorderColor">border color of planned resource in `#XXxxXX` format</param>
   * <param name="TotalRoundsCount"></param>
   * <param name="Resource"></param>
   */
  PlannedResource?: PlannedResourceWithResourcePortable;

  /** Types of BasicStudyPeriods */
  Type?: TimetableItemTypes;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  PlannedTime?: string;
}

export interface ScheduledStudyWithScheduledElementPortable {
  /** @format int32 */
  ScheduledStudyId?: number;

  /** @format int32 */
  ScheduledPeriodId?: number;

  /** @format int32 */
  TimetableItemId?: number;

  /**
   * @format date
   * @example 2023-10-09
   */
  Day?: string;

  /** @format int32 */
  EnrollmentId?: number | null;

  /** @format int32 */
  Position?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Start?: string | null;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Duration?: string;

  /** Types of BasicStudyPeriods */
  Type?: TimetableItemTypes;
  Comment?: string | null;
  WeekDay?: ZeroBasedWeekDays;
  PlannedResource?: ScheduledStudyPlannedResourcePortable;
  Elements?: ScheduledElementItem[] | null;
}

export interface SortOrder {
  /** Column to sort */
  Column?: string | null;
  Direction?: SortOrders;

  /**
   * Position of this sort through others
   * @format int32
   */
  Position?: number;
}

export enum SortOrders {
  Ascending = "Ascending",
  Descending = "Descending",
}

/**
 * Represent Action that must be shown on analysis page
 */
export enum StudyAnalyseAction {
  Optimize = "Optimize",
  SetExamDate = "SetExamDate",
  StartPlanning = "StartPlanning",
  None = "None",
}

export interface StudyAnalyseOutput {
  /**
   * When study will be finished from today by percent.
   * Can be any value from 0% to more than 100%, but values more than 120% must be treated as 120%.
   * Client app can determine which color must be used to fill chart, and how many lines must be filled with that color.
   * If value (=x) was less than 100, chart must be green, and x% colored from left, remaining lines in gray.
   * If value (=x) was greater or equal than 100, chart must be red.
   * if value was between 100%~119%, end part of chart will NOT be colored in red (and remains gray)
   * if value was equal or more than 120%, end part of chart will be colored in red
   * @format int32
   */
  FinishPercent?: number;

  /**
   * Text says when study ends before or after exam day.
   *             If study will be finished less than a week before or after exam, this text will be something like "3 days after exam" or "5 days before exam".
   *             If study will be finished less than 4 weeks before or after exam, this text will be something like "2 weeks before exam"
   *             If study will be finished less than 6 months before or after exam, this text be something like "3 and half months after exam" or "2 months before exam". (less than 6 month, includes half of month)
   *             If study will be finished more than 6 months before or after exam, this text be something like "8 months after exam" or "7 months before exam". (more than 6 month, does not includes half of month)
   */
  FinishComment?: string | null;

  /** Represent Action that must be shown on analysis page */
  Action?: StudyAnalyseAction;
  Items?:
    | PlannedResourceAnalysisWithPlannedResourceWithResourcePortable[]
    | null;
}

export interface StudyPeriodInvalidPositionDetails {
  /** @format int32 */
  Position?: number;
}

export interface StudyPeriodInvalidPositionDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: StudyPeriodInvalidPositionDetails;
}

export interface StudyPeriodMaxPlannableTimeExceedDetails {
  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  CurrentPlanned?: string;
}

export interface StudyPeriodMaxPlannableTimeExceedDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: StudyPeriodMaxPlannableTimeExceedDetails;
}

/**
 * Specifies how Study Period will be started
 */
export enum StudyPeriodStartTypes {
  Fixed = "Fixed",
  Ordinary = "Ordinary",
}

/**
* <param name="Period">Information of selected period</param>
<param name="HasNextPeriod">Determine whether the next period exists or not. </param>
<param name="HasPreviousPeriod">Determine whether the previous period exists or not. </param>
<param name="LastIndex">Last Index exist for enrollment </param>
<param name="Items">List of Items of selected period</param>
*/
export interface StudyScheduleOutput {
  /**
   * <param name="ScheduledPeriodId"></param>
   * <param name="EnrollmentId"></param>
   * <param name="ExamPeriod">If this period, is last period before exam</param>
   * <param name="StudiedHoursCount"></param>
   * <param name="FinishedChaptersCount"></param>
   * <param name="TotalChaptersCount"></param>
   * <param name="UnplannedChaptersCount"></param>
   * <param name="StartDate"></param>
   * <param name="EndDate"></param>
   * <param name="Type"></param>
   * <param name="Index">Index of period, such as 23</param>
   */
  Period?: ScheduledPeriodPortable;
  HasNextPeriod?: boolean;
  HasPreviousPeriod?: boolean;

  /** @format int32 */
  LastIndex?: number;
  Items?: ScheduledStudyWithScheduledElementPortable[] | null;
}

/**
 * When studying a resource will be finished what do you expect from 3Gaam to do for you?
 */
export enum TimetableItemFinishedActions {
  Automatic = "Automatic",
  RestudyResource = "RestudyResource",
  SwitchReview = "SwitchReview",
  RemoveStudyPeriod = "RemoveStudyPeriod",
  ChangeResource = "ChangeResource",
}

export interface TimetableItemOverlapsDetails {
  OverlappedStudyPeriods?: TimetableItemPortable[] | null;
}

export interface TimetableItemOverlapsDetailsTypedExceptionResponse {
  Title?: string | null;
  Debug?: string | null;
  Type?: string | null;
  Details?: TimetableItemOverlapsDetails;
}

/**
* Applicant view of TimetableItemEntity/>
<param name="BasicStudyPeriodId"></param><param name="EnrollmentId">Enrollment that this study period belongs to</param><param name="Position">If related Segaam.Planning.InternalContracts.Plan.IEnrollmentEntity.StudyPeriodsStartType equals to Segaam.Planning.InternalContracts.Enrollment.StudyPeriodStartTypes.Ordinary, this property order number and position of this study period</param><param name="Start">If related Segaam.Planning.InternalContracts.Plan.IEnrollmentEntity.StudyPeriodsStartType equals to Segaam.Planning.InternalContracts.Enrollment.StudyPeriodStartTypes.Fixed, this property holds exact time of beginning. This value is measured from beginning of day (00:00:00) and must not be negative or more than 23:59:59</param><param name="Duration">Time planned for this study period</param><param name="ResourceId"></param><param name="Type">Holds type of a StudyPeriod (any of Resource, Review and Free)</param><param name="Comment">Used for comment of SP if SP type was Free</param><param name="WeekDay">Day of week that this periods belongs to it</param>
*/
export interface TimetableItemPortable {
  /** @format int32 */
  BasicStudyPeriodId?: number;

  /** @format int32 */
  EnrollmentId?: number;

  /** @format int32 */
  Position?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Start?: string | null;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Duration?: string;

  /** @format int32 */
  ResourceId?: number | null;

  /** Types of BasicStudyPeriods */
  Type?: TimetableItemTypes;
  Comment?: string | null;
  WeekDay?: ZeroBasedWeekDays;
}

/**
 * Types of BasicStudyPeriods
 */
export enum TimetableItemTypes {
  Study = "Study",
  Review = "Review",
  Free = "Free",
}

/**
 * Applicant view of TimetableItemEntity/>
 */
export interface TimetableItemWithColorWithResourcePortable {
  /** @format int32 */
  BasicStudyPeriodId?: number;

  /** @format int32 */
  EnrollmentId?: number | null;

  /** @format int32 */
  Position?: number;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Start?: string | null;

  /**
   * [-][d.]hh:mm:ss[.fffffff]
   * @example 12:34:56
   */
  Duration?: string;

  /** Types of BasicStudyPeriods */
  Type?: TimetableItemTypes;
  Comment?: string | null;
  WeekDay?: ZeroBasedWeekDays;
  HexadecimalColor?: string | null;
  HexadecimalBorderColor?: string | null;

  /**
   * Applicant view of a book
   * <param name="ResourceId"></param><param name="Title"></param><param name="Publisher"></param><param name="Authors"></param><param name="Translators"></param><param name="Narrators"></param><param name="Cover"></param><param name="ResourceType"></param><param name="ContentType"></param><param name="ProgressType"></param><param name="TotalProgressIndex"></param><param name="Edition"></param><param name="Priotizable">If has any chapter that is marked as important, allows applicant to select which parts of resource wants to study</param><param name="Volumeable">If has any chapter that is volumeable (testable), allows applicant to select quiz volume</param><param name="Reviewable">If has any reviewable chapter</param><param name="Turboable"></param><param name="ContainChapter"></param>
   */
  Resource?: ResourcePortable;
}

export interface TimetableItemsQueryOutput {
  /** Returning Items */
  Items?: TimetableItemWithColorWithResourcePortable[] | null;

  /**
   * corresponding to the first cursor of Items
   * @format int32
   */
  StartCursor?: number | null;

  /**
   * corresponding to the last cursor of Items
   * @format int32
   */
  EndCursor?: number | null;

  /** is used to indicate whether more edges exist following the set defined by the clients arguments */
  HasNext?: boolean;

  /** is used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  HasPrevious?: boolean;

  /**
   * Count of total records matching this query
   * @format int32
   */
  TotalCount?: number | null;
}

/**
 * نوع یک گره در ساختار درختی را مشخص می‌کند
 */
export enum TreeNodeTypes {
  ContainerNoOthers = "ContainerNoOthers",
  Value = "Value",
  Container = "Container",
}

export interface UnplanChapterInput {
  /** @format uuid */
  ConsulteeId?: string | null;

  /** @format int32 */
  PlannedChapterId?: number;
}

export interface UnplanChapterOutput {
  SchedulesRegenerateNeeded?: boolean;
}

/**
 * Input of service to remove a book (resource) from plan
 */
export interface UnplanResourceInput {
  /** @format int32 */
  PlannedResourceId?: number;
  ClearHistory?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface UnplanResourceOutput {
  Success?: boolean;
  SchedulesRegenerateNeeded?: boolean;
}

export interface UpdateApplicantProfileCore {
  LastUniversityName?: string | null;
  LastDegreeName?: string | null;
  LastFieldName?: string | null;
  LastGPA?: string | null;
}

/**
* <param name="ConsulteeId"></param>
<param name="LastUniversityName"></param>
<param name="LastDegreeName"></param>
<param name="LastFieldName"></param>
<param name="LastGPA"></param>
*/
export type UpdateApplicantProfileInput = UpdateApplicantProfileCore & {
  ConsulteeId?: string | null;
};

export type UpdateApplicantProfileOutput = object;

export interface UpdateEnrollmentInput {
  /** @format int32 */
  FinalReviewDaysCount?: number;
  WeekStart?: ZeroBasedWeekDays;
  AutoGenerateApplicantMissedReports?: boolean;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface UpdateEnrollmentOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface UpdatePlannedChapterCompletedPercentInput {
  /** @format uuid */
  ConsulteeId?: string | null;

  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PlannedChapterId?: number;

  /**
   * @format int32
   * @min 0
   * @max 100
   */
  CompletedPercent?: number;
}

export interface UpdatePlannedChapterCompletedPercentOutput {
  SchedulesRegenerateNeeded?: boolean;
}

/**
 * Configuration of studying a resource
 */
export interface UpdatePlannedResourceInput {
  /** @format int32 */
  PlannedResourceId?: number;

  /** @format uuid */
  ConsulteeId?: string | null;
  ReviewAutomatically?: boolean;

  /** Which chapters applicant wants to read */
  PartialStudyMethod?: PlannedResourceStudyParts;
  QuizVolume?: PlannedResourceQuizVolumes;
  QuizPart?: PlannedResourceQuizParts;
}

export interface UpdatePlannedResourceOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface UpdateProfileInput {
  FirstName?: string | null;
  LastName?: string | null;

  /** @format int32 */
  CityId?: number | null;

  /**
   * @format date
   * @example 2023-10-09
   */
  Birthdate?: string | null;
  IBAN?: string | null;
}

export interface UpdateProfilesInput {
  Membership?: UpdateProfileInput;
  Applicant?: UpdateApplicantProfileCore;
}

export type UpdateProfilesOutput = object;

export interface UpdateResourceRequestInput {
  /** @format int32 */
  ResourceRequestId?: number;
  Title?: string | null;
  ResourceType?: ResourceType;
  Publisher?: string | null;
  Authors?: string | null;
  Translators?: string | null;
  Narrators?: string | null;
  ISBN10?: string | null;
  ISBN13?: string | null;

  /** @format int32 */
  Edition?: number | null;

  /** @format int32 */
  CoverFileId?: number;
  ProgressType?: ProgressType;

  /** @format int32 */
  TotalProgressIndex?: number;

  /** @format int32 */
  LanguageId?: number | null;
  ReferenceLink?: string | null;
  Images?: RequestResourceImageInput[] | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface UpdateResourceRequestOutput {
  /** @format int32 */
  ResourceRequestId?: number;
  Status?: ResourceRequestStatus;
  LastActivity?: RequestResourceActivityPortable;
}

export interface UpdateTimetableItemFinishedActionInput {
  /** @format int32 */
  StudyPeriodId?: number;

  /** When studying a resource will be finished what do you expect from 3Gaam to do for you? */
  FinishedAction?: TimetableItemFinishedActions;

  /**
   * id of PlannedResource to be replaced with current resource
   * @format int32
   */
  FinishedReplacementResourceId?: number | null;

  /** @format uuid */
  ConsulteeId?: string | null;
}

export interface UpdateTimetableItemFinishedActionOutput {
  SchedulesRegenerateNeeded?: boolean;
}

export interface UploadResourceRequestImageOutput {
  /** @format int32 */
  FileId?: number;
  Thumbnail?: string | null;
}

export enum ZeroBasedWeekDays {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}

export interface DeleteV0BasicPlanningCommandRemoveTimetableItemNullableGuidConsulteeIdInt32TimetableItemIdParams {
  /**
   * Id of StudyPeriod to delete.
   * @format int32
   */
  TimetableItemId?: number;
}

export interface GetV0BasicPlanningQueryTimetableItemsNullableGuidConsulteeIdInt32CountInt32StartPointInfiniteScrollDirectionDirectionNullableInt32FilterTimetableItemIdNullableInt32FilterResourceIdNullableInt32FilterPositionNullableTimeSpanFilterDurationParams {
  /**
   * تعداد اقلام دریافتی از صفحه
   * تعداد پیش فرض 25 می باشد
   * @format int32
   * @min 1
   * @max 100
   */
  Count?: number;

  /**
   * محل شروع برای حرکت رو به جلو یا عقب در صورتی که محل شروع تعیین نشود بسته به جهت
   * به داد تعیین شده از ابتدا یا انتها خوانده میشود
   * @format int32
   */
  StartPoint?: number;

  /** جهت حرکت رو به جلو یا عقب را مشخص می کند که پیش فرض رو به جلو می باشد */
  Direction?: InfiniteScrollDirection;

  /** @format int32 */
  "Filter.TimetableItemId"?: number;

  /**
   * Resource to be studied
   * @format int32
   */
  "Filter.ResourceId"?: number;

  /**
   * Position of this SP against others in the day
   * @format int32
   */
  "Filter.Position"?: number;

  /**
   * Time planned for this study period
   * @example 12:34:56
   */
  "Filter.Duration"?: string;
}

export interface GetV0JobStateInt32JobIdParams {
  /** @format int32 */
  jobId?: number;
}

export interface PostV0ManagerCoreInvalidateClientVersionsCacheBooleanCascadeParams {
  cascade?: boolean;
}

export interface GetV0MicroscopicQueryStudyScheduleNullableInt32PeriodIndexNullableGuidConsulteeIdParams {
  /** @format int32 */
  PeriodIndex?: number;

  /** @format uuid */
  ConsulteeId?: string;
}

export interface GetV0MicroscopicQueryReviewScheduleNullableInt32PeriodIndexNullableGuidConsulteeIdParams {
  /** @format int32 */
  PeriodIndex?: number;

  /** @format uuid */
  ConsulteeId?: string;
}

export interface GetV0MicroscopicQueryChapterSpeedConfigurationInt32PlannedResourceIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  PlannedResourceId?: number;
}

export interface GetV0MicroscopicQueryResourceSpeedConfigurationInt32PlannedResourceIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  PlannedResourceId?: number;
}

export interface GetV0MicroscopicQueryReportableElementsNullableInt32PeriodIndexNullableGuidConsulteeIdParams {
  /** @format int32 */
  PeriodIndex?: number;

  /** @format uuid */
  ConsulteeId?: string;
}

export interface GetV0MicroscopicQueryResourcesProgressReportsNullableInt32PeriodIndexNullableGuidConsulteeIdParams {
  /** @format int32 */
  PeriodIndex?: number;

  /** @format uuid */
  ConsulteeId?: string;
}

export interface GetV0MicroscopicQueryChaptersPlannedTimeSumReportsNullableGuidConsulteeIdParams {
  /** @format uuid */
  ConsulteeId?: string;
}

export interface GetV0MicroscopicQueryPeriodicElementReportsNullableInt32PeriodIndexNullableGuidConsulteeIdParams {
  /** @format int32 */
  PeriodIndex?: number;
}

export interface GetV0PlanningGeneralQueryExamsQuerySortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterExamIdStringFilterTitleStringFilterDescriptionNullableBooleanFilterIsActiveNullableInt32FilterPositionParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.ExamId"?: number;
  "Filter.Title"?: string;
  "Filter.Description"?: string;
  "Filter.IsActive"?: boolean;

  /** @format int32 */
  "Filter.Position"?: number;
}

export interface GetV0PlanningGeneralQueryExamDatesQuerySortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterExamDateIdNullableInt32FilterExamIdNullableLocalDateFilterDateMinNullableLocalDateFilterDateMaxStringFilterTitleParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.ExamDateId"?: number;

  /** @format int32 */
  "Filter.ExamId"?: number;

  /**
   * @format date
   * @example 2023-10-09
   */
  "Filter.Date.Min"?: string;

  /**
   * @format date
   * @example 2023-10-09
   */
  "Filter.Date.Max"?: string;
  "Filter.Title"?: string;
}

export interface GetV0PlanningGeneralQueryFieldsQuerySortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterFieldIdInt32FilterExamIdStringFilterTitleStringFilterDescriptionParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.FieldId"?: number;

  /** @format int32 */
  "Filter.ExamId"?: number;
  "Filter.Title"?: string;
  "Filter.Description"?: string;
}

export interface GetV0PlanningGeneralQueryBranchesQuerySortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterBranchIdInt32FilterFieldIdStringFilterTitleStringFilterDescriptionNullableInt32FilterPositionNullableBooleanFilterSupportsConsultantParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.BranchId"?: number;

  /** @format int32 */
  "Filter.FieldId"?: number;
  "Filter.Title"?: string;
  "Filter.Description"?: string;

  /** @format int32 */
  "Filter.Position"?: number;
  "Filter.SupportsConsultant"?: boolean;
}

export interface PostV0ResourcesCommandUploadResourceRequestImageIFormFileImageNullableGuidConsulteeIdPayload {
  /** @format binary */
  Image?: File;
}

export interface GetV0ResourcesQueryResourcePackagesNullableGuidConsulteeIdSortOrderSortOrdersNullableInt32FilterResourcePackageIdNullableInt32FilterPositionStringFilterTitleStringFilterSubtitleNullableBooleanFilterPublishedNullableInt32FilterBranchIdParams {
  SortOrders?: SortOrder[];

  /** @format int32 */
  "Filter.ResourcePackageId"?: number;

  /**
   * Position of this package against other packages, lower, means upper or sooner
   * @format int32
   */
  "Filter.Position"?: number;

  /** Title of package */
  "Filter.Title"?: string;

  /** Subtitle of package that will be displayed below of title in list of packages */
  "Filter.Subtitle"?: string;

  /** Allows some packages to stop being published temportairly */
  "Filter.Published"?: boolean;

  /**
   * Branch who this package is generated for
   * @format int32
   */
  "Filter.BranchId"?: number;
}

export interface GetV0ResourcesQueryResourcePackageResourcesInt32PackageIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  PackageId?: number;
}

export interface GetV0ResourcesQueryApplicantResourcesQueryNullableGuidConsulteeIdInt32CountStringStartPointInfiniteScrollDirectionDirectionStringFilterQueryParams {
  /**
   * تعداد اقلام دریافتی از صفحه
   * تعداد پیش فرض 25 می باشد
   * @format int32
   * @min 1
   * @max 100
   */
  Count?: number;

  /**
   * محل شروع برای حرکت رو به جلو یا عقب در صورتی که محل شروع تعیین نشود بسته به جهت
   * به داد تعیین شده از ابتدا یا انتها خوانده میشود
   */
  StartPoint?: string;

  /** جهت حرکت رو به جلو یا عقب را مشخص می کند که پیش فرض رو به جلو می باشد */
  Direction?: InfiniteScrollDirection;

  /** If filled, only resources with name, author, publisher or description that contain query will be returned */
  "Filter.Query"?: string;
}

export interface GetV0ResourcesQueryChaptersQuerySortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterChapterIdNullableInt32FilterResourceIdStringFilterTitleNullableInt32FilterPositionStringFilterDescriptionParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.ChapterId"?: number;

  /** @format int32 */
  "Filter.ResourceId"?: number;
  "Filter.Title"?: string;

  /** @format int32 */
  "Filter.Position"?: number;
  "Filter.Description"?: string;
}

export interface GetV0ResourcesQueryPlannedChaptersQueryNullableGuidConsulteeIdSortOrderSortOrdersBooleanQueryCountInt32PageIndexInt32PageSizeNullableInt32FilterChapterIdNullableInt32FilterEnrollmentIdNullableInt32FilterPlannedChapterIdNullableInt32FilterPlannedResourceIdNullableBooleanFilterPostponedNullableBooleanFilterManuallyRemovedNullableBooleanFilterUnimportantlyRemovedNullablePlannedChapterStatesFilterStateParams {
  SortOrders?: SortOrder[];

  /** If was true, queries for total count of records. If was false, skips count of total records */
  QueryCount?: boolean;

  /**
   * Index of requested page (started from 1, NOT 0)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Maximum rows to be returned in each page
   * According to excel output, maximum page size increased to 9999
   * @format int32
   * @min 1
   * @max 9999
   */
  PageSize?: number;

  /** @format int32 */
  "Filter.ChapterId"?: number;

  /** @format int32 */
  "Filter.EnrollmentId"?: number;

  /** @format int32 */
  "Filter.PlannedChapterId"?: number;

  /** @format int32 */
  "Filter.PlannedResourceId"?: number;
  "Filter.Postponed"?: boolean;
  "Filter.ManuallyRemoved"?: boolean;
  "Filter.UnimportantlyRemoved"?: boolean;
  "Filter.State"?: PlannedChapterStates;
}

export interface GetV0ResourcesQueryPlannedResourcesQueryNullableGuidConsulteeIdInt32CountStringStartPointInfiniteScrollDirectionDirectionBooleanFilterHideRequestsParams {
  /**
   * تعداد اقلام دریافتی از صفحه
   * تعداد پیش فرض 25 می باشد
   * @format int32
   * @min 1
   * @max 100
   */
  Count?: number;

  /**
   * محل شروع برای حرکت رو به جلو یا عقب در صورتی که محل شروع تعیین نشود بسته به جهت
   * به داد تعیین شده از ابتدا یا انتها خوانده میشود
   */
  StartPoint?: string;

  /** جهت حرکت رو به جلو یا عقب را مشخص می کند که پیش فرض رو به جلو می باشد */
  Direction?: InfiniteScrollDirection;
  "Filter.HideRequests"?: boolean;
}

export interface GetV0ResourcesQueryPlannedResourceDetailsInt32PlannedResourceIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  PlannedResourceId?: number;
}

export interface GetV0ResourcesQueryResourceRequestInt32ResourceRequestIdNullableGuidConsulteeIdParams {
  /** @format int32 */
  ResourceRequestId?: number;
}

export interface GetV0ResourcesQueryPreviewExternalResourceStringIdentifierParams {
  Identifier?: string;
}
